import React from "react";
import { motion } from "framer-motion";

/**
 * DropdownIndicator Component
 * Animated indicator that shows which dropdown menu is currently active
 */
const DropdownIndicator = ({ isActive, children }) => {
  return (
    <div className="relative">
      {children}

      {/* Animated underline indicator */}
      {isActive && (
        <motion.div
          className="absolute bottom-0 left-0 w-full h-0.5 bg-brandAccent"
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          exit={{ scaleX: 0 }}
          transition={{ duration: 0.2 }}
          layoutId="dropdown-indicator"
        />
      )}
    </div>
  );
};

export default DropdownIndicator;
